import { CurrencyExchange } from '@mui/icons-material';
import TransactionHistoryManagement from './TransactionHistoryManagement';

export default {
    icon: CurrencyExchange,
    recordRepresentation: 'reference',
    list: TransactionHistoryManagement
};
